export const GOVUK = "govuk";
export const MUI = "mui";
export const ANT = "ant";

export const settings = {
  UI: MUI,
};

export const transactionCurrencyBWP = "2816026f-bf51-ec11-8f8e-000d3a7ef8c6";
